import { Component, OnInit, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';

@Component({
  selector: 'app-currency-select',
  templateUrl: './currency-select.component.html',
  styleUrls: ['./currency-select.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CurrencyFareSelectComponent, multi: true }]
})
export class CurrencyFareSelectComponent implements OnInit, ControlValueAccessor {
  @Input() title;
  @Input() hidePlusSign;

  touched = [];
  changed = [];
  public _value: any;
  currency_type: string;
  currencyForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    let isNum = (num: AbstractControl) => {
      let pureNumber = num.value;
      pureNumber = pureNumber.substr(1);
      isNaN(parseInt(pureNumber)) ? { is_nan: true } : null;
    };

    this.currencyForm = this.fb.group({
      percent: ['', [Validators.required, Validators.min(-100), Validators.max(100), isNum]],
      natural: ['', [Validators.required, isNum]]
    });
  }

  get value() {
    if (this.currency_type == 'natural') {
      return this.currencyForm.value.natural;
    } else {
      return this.currencyForm.value.percent + '%';
    }
  }

  set value(value: any) {
    this._value = value.toString();
    if (this.hidePlusSign != undefined && value.indexOf('+') == 0) {
      this._value = value.toString().substr(1);
    }
    if (this._value.substr(-1) == '%') {
      this.currency_type = 'percent';
      this.currencyForm.get('percent').setValue(this._value.substr(0, this._value.length - 1));
      this.currencyForm.get('natural').setValue('');
      this.currencyForm.get('natural').markAsUntouched();
    } else {
      this.currency_type = 'natural';
      this.currencyForm.get('natural').setValue(this._value);
      this.currencyForm.get('percent').setValue('');
      this.currencyForm.get('percent').markAsUntouched();
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.changed.push(fn);
  }

  registerOnTouched(fn: any): void {
    this.touched.push(fn);
  }

  touch() {
    this.touched.map(f => f());
  }

  input(controlName) {
    this.changed.map(f => {
      f(this.value);
      this.currencyForm.get(controlName).markAsTouched();
    });
  }

  switch(typeOf, typeOn) {
    this.currencyForm.get(typeOf).setValue('');
    this.currencyForm.get(typeOf).markAsUntouched();
    this.currency_type = typeOn;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/currency-select/currency-select.component.ts